export const validateGroupName = (name: string) => {
  switch (name) {
    case 'anoIds':
      return 'ano'
    case 'anosSelectIds':
      return 'ano'
    case 'mesesIds':
      return 'mes'
    case 'mesesSelectIds':
      return 'mes'
    case 'fatorIds':
      return 'fator'
    case 'fatorSelectIds':
      return 'fator'
    default:
      return null
  }
}
